document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('[data-currency-toggle]');
  if (!toggle) return;

  const buttons = toggle.querySelectorAll('[data-currency]');
  const usdPrices = document.querySelectorAll('[data-price-usd]');
  const arsPrices = document.querySelectorAll('[data-price-ars]');
  const links = document.querySelectorAll('.hm-product-link');

  function setCurrency(currency) {
    buttons.forEach((button) => {
      button.classList.toggle('is-active', button.dataset.currency === currency);
    });

    usdPrices.forEach((el) => {
      el.hidden = currency !== 'usd';
    });

    arsPrices.forEach((el) => {
      el.hidden = currency !== 'ars';
    });

    links.forEach((link) => {
      const nextHref =
        currency === 'ars'
          ? link.dataset.linkArs || link.dataset.linkUsd || '#'
          : link.dataset.linkUsd || link.dataset.linkArs || '#';

      link.setAttribute('href', nextHref);
    });

    try {
      localStorage.setItem('hm_currency', currency);
    } catch (e) {}
  }

  buttons.forEach((button) => {
    button.addEventListener('click', function () {
      setCurrency(button.dataset.currency);
    });
  });

  let saved = 'usd';
  try {
    saved = localStorage.getItem('hm_currency') || 'usd';
  } catch (e) {}

  setCurrency(saved);
});

document.addEventListener('DOMContentLoaded', function () {
  const reviewCards = document.querySelectorAll('.hmrev-card');
  if (!reviewCards.length) return;

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    },
    { threshold: 0.2 }
  );

  reviewCards.forEach((card) => io.observe(card));
});

document.addEventListener("DOMContentLoaded", function(){

  const toggle = document.getElementById("hmMobileToggle");
  const sidebar = document.querySelector(".hmdb-sidebar--fixed");

  if(!toggle || !sidebar) return;

  toggle.addEventListener("click", function(){
    sidebar.classList.toggle("is-open");
  });

});